import { render, staticRenderFns } from "./CreateRefModalContent.vue?vue&type=template&id=1b8e3164&scoped=true&"
import script from "./CreateRefModalContent.vue?vue&type=script&lang=js&"
export * from "./CreateRefModalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8e3164",
  null
  
)

export default component.exports